<template>
    <div class="home_wrap">
        <van-nav-bar title="Extra Initial Deposit Bonus" left-text="" left-arrow :fixed="true"
            @click-left="onClickLeft" />

        <div class="bonus-wrap">
            <div>There are no prizes to be received at this time</div>
            <table>
                <tr class="tb-bgl">
                    <th>First recharge</th>
                    <th>Reward Value</th>
                </tr>
                <tr v-for="(item, index) in rechargeConfigList" :key="index" :class="index % 2 == 1 ? 'tb-bgl' : ''">
                    <td>≥{{ item.min_money }}</td>
                    <td>{{ item.gift_amount }}</td>
                </tr>
            </table>
        </div>
        <div class="bonus_bottom">
            <div ><span>Event Instructions:</span>
                <div>1.Exclusive for the first account top-up, with just one chance. The more you recharge,
                    More rewards you receive, the highest reward being 3777;<br>2.No limit deposit. Rewards
                    scheduled to be updated in 10 minutes. Please wait for the distribution of the
                    reward;<br>3.Rewards received can only be redeemed after Today00:00:00. The rescue only
                    can be done manually on APP/iOS、APP/Android、PC/Windows.<br>4.Rewards received
                    will expire 1 day after the end of each cycle. Expired rewards will be canceled
                    automatically;<br>5.The bonus (main+bonus) given by this activity requires that1 bet
                    valid, and betting is an unlimited gaming platform;<br>6.This event is limited to operations
                    norMore carried out by the account holder. It is prohibited to rent, use external plug-ins, robots, bet
                    on different accounts, mutual brushing, arbitration, interface, protocol, exploitation of
                    vulnerabilities, group control or other technical means to participate. Otherwise, the
                    rewards will be canceled or deducted, the account will be frozen or even added to the list
                    black;<br>7.In order to avoid differences in understanding the text, the platform will maintain the interpretation
                    end of this event.<br></div>
            </div>
        </div>

        <ftNav></ftNav>
    </div>
</template>
<script>
import Fetch from '../../utils/fetch';

import Vue from 'vue';
import ftNav from "../../components/footer_nav/footer_nav"
import { NavBar } from 'vant';


Vue.use(NavBar);
export default {
    name: "rechargeBonus",
    components: {
        ftNav
    },
    data() {
        return {
            rechargeConfigList: [],
        }
    },
    created() {
        this.$bus.$emit('send2ftnav', 1);
        //this.active_list();
        Fetch("/recharge/rechargeConfigList", {}).then((res) => {
            //console.log(res);
            if (res.data.is_open) {
                this.rechargeConfigList = res.data.config_list;
            }
        });
    },
    beforeDestroy() {
    },
    mounted() {

    },
    methods: {
        onClickLeft() {
            this.$router.push("/activity");
        }


    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar {
    background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
    color: @textcolorf;
}

/deep/ .van-nav-bar__title {
    color: @textcolorf;
}

.home_wrap {
    width: 100%;
    min-height: 100vh;
    //background-color: rgba(0, 0, 0,0.5);
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.bonus-wrap {
    width: 95%;
    margin: 0 auto;
    font-size: 0.36rem;
    div {
        width: 100%;
        color: @textcolorf;
        padding: 0.4rem 0.2rem;
        box-sizing: border-box;
        text-align: center;
        background-color:@secondary-color;
    }

    table {
        padding: 0.4rem 0.2rem;
        text-align: center;
        margin-top: 0.3rem;
        color: @textcolorf;
        width: 100%;
        background-color: @secondary-color;
    }

    th {
        width: 50%;
        padding: 0.2rem;
    }

    td {
        padding: 0.2rem;
    }
}

.tb-bgl {
    background-color: @third-color;
}
.bonus_bottom{
    width: 95%;
    margin: 0.3rem auto;
    padding: 0.4rem;
    box-sizing: border-box;
    background-color: @secondary-color;
    font-size: 0.36rem;
    span{
        color: @textcolorf;
        
        font-weight: 700;
    }
    div{
        color: @textcolorf;
    }
}

</style>